import theme from "src/themeNew";

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0',
    margin: '0px',
    '& .MuiDialog-paper': {
      margin: '0px',
      borderRadius: '0',
    },
    '& .MuiPaper-root': {
      height: '100%',
      maxHeight: '100%',
    }
  },
  container: {
    height: '100%',
    width: '450px',
    display: 'flex',
    flexDirection: 'column'
  },
  modalHeader: {
    height: '72px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderBottom: '1px solid #4C4E641F',
    padding: '16px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '500',
    color: theme.palette.text.primary,
    lineHeight: '28px',
    letter: '-0.25px',
  },
  closeBtn: {
    padding: '0px',
  },
  closeIcon: {
    height: '18px',
    width: '18px',
    color: theme.palette.text.secondary,
  },
  modalContent: {
    flex: 1,
    padding: '20px 24px',
  },
  addNewForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  fieldContainer: {
  },
  descr: {
    fontSize: '13px',
    fontWeight: '500',
    color: theme.palette.text.secondary,
    lineHeight: '22px',
    letter: '-0.25px',
  },
  label: {
    fontSize: '13px',
    fontWeight: '500',
    color: theme.palette.text.primary,
    lineHeight: '22px',
    letter: '-0.25px',
  },
  formControl: {
    padding: '8px 0px',
  },
  selectStyle: {
    height: '36px',
    width: '100%',
    borderRadius: '4px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.palette.border.input} !important`,
    },
  },
  selectItem: {
    fontSize: '14px !important',
    color: theme.palette.text.primary,
    height: '32px',
  },
  checkBox: {
    padding: '0px',
    marginRight: '8px',
    color: '#C2CFE099',
    '&.Mui-checked': {
      borderRadius: '4px',
    },
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '8px'
  },
  inputField: {
    fontSize: '14px',
    color: theme.palette.text.primary,
    border: 0,
    backgroundColor: theme.palette.code.light,
    padding: '8px 12px',
    flex: 1,
    margin: '0px',
    borderRadius: '4px'
  },
  copyBtn: {
    padding: '6px',
  },
  copyIcon: {
    width: '18px',
    height: '18px',
  },
  checkIcon: {
    color: '#4caf50',
    width: '18px',
    height: '18px',
  },
  integrationBody: {
    flex: 1,
    marginTop: '5px',
    marginBottom: '-10px'
  },
  integrationTitle: {
    fontSize: '15px',
    fontWeight: '600',
    color: theme.palette.text.primary
  },
  integrationDesc: {
    fontSize: '13px',
    color: theme.palette.text.secondary,
    minHeight: '42px'
  },
  modalFooter: {
    height: '102px',
    width: '100%',
    padding: '32px 20px',
    border: `1px solid ${theme.palette.border.footer}`,
    boxShadow: `0px 2px 6px 0px ${theme.palette.boxShadow.primary}`
  },
}

export default styles;
